import enCA from './en-CA';
import frCA from './fr-CA';

import LOCALES from './localeTypes';

const messages = {
    [LOCALES.EN]: enCA,
    [LOCALES.FR]: frCA
};

export default messages;


// WEBPACK FOOTER //
// ./src/constants/locale/messages.js